import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";

import "./assets/main.scss";
import "./assets/base.scss";


const app = createApp(App);


app.use(createPinia());
app.mount("#fpe-root");
